<div [ngClass]="(mobile)?'container is-fluid':'container'">
  <div class="hero progress"></div>


  <app-progress-bar value="66"></app-progress-bar>

  <ng-container *ngIf="!isTaxPlatform">
    <app-authority-information></app-authority-information>
  </ng-container>

  <div class="container">
    <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" timeOut="0" display="true"
                      error=true data-testid="error-notification"></app-notification>
  </div>
  <div class="columns is-gapless">
    <div class="column has-border has-round-border" style="padding: 10px!important;">
      <div class="columns">
        <div class="column ml-4">
          <div class="card__box__head">
            <span class="title is-5 is-bold" style="color: #35566E">Berechtigtes Interesse</span>
          </div>
          <app-legitimate-interest-selector [(selectedValue)]="legitimateInterest" (selectionChanged)="displayNachweis()"></app-legitimate-interest-selector>
        </div>
      </div>
    </div>
  </div>
  <div class="columns is-gapless">
    <div  [ngClass]="{'disabled': legitimateInterest==='init' || hasGeneralAuthority()}" id="authority" class="column has-border has-text-centered" style="padding: 10px!important; border-radius: 25px 0 0 25px" data-testid="authority-container">
      <div [ngClass]="(mobile)?'container is-fluid':'container'">

        <div class="columns">
          <div class="column is-2">
            <div class="title is-4 is-left is-darkblue " style="float: left">(1)</div>
          </div>
          <div class="column">
            <h1 class="title is-4 is-darkblue has-text-weight-bold is-uppercase is-spaceless">
              Vollmacht </h1>
            <p class="is-lightblue is-spaced mb-3 is-size-7">Eigentümerpartei an Vertreter + DocEstate GmbH</p>
          </div>
          <div class="column is-2">
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div [ngClass]="{'is-hidden':!hasGeneralAuthority()}" id="authority-success" class="notification is-success" data-testid="generalauthority-information">
              Ihre Generalvollmacht ist bereits hinterlegt!
            </div>

            <div>
              <app-dropzone #authorityDropzone [authorityType]="'authority'" dropzoneImage="assets/images/dropzone/upload-icon2.svg"></app-dropzone>
            </div>
            <div class="files-list" *ngIf="authorityData" data-testid="authority-signing-container">
              <p class="is-size-6" *ngIf="authorityData.signingUrl !== null" data-testid="authority-signing-information">Die Vollmacht wurde unterzeichnet</p>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <button *ngIf="legitimateInterest === 'owner'" (click)="downloadAuthorityPdfTemplate()"
                    class="is-clickable color-white has-round-border is-15 has-background-blue no-border is-bold is-pulled-right download-authority-button-padding is-flex is-align-items-center">
              <span class="is-size-7 mr-2">Vollmachtvorlage</span>
              <span class="download-icon">
                    <img alt="Download" src="assets/images/download_icon/download_icon.svg" style="height: 1rem;"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div  [ngClass]="{'disabled': legitimateInterest ==='init','is-hidden':displayNachweisDrop}" id="sub-authority" class="column has-border has-text-centered" style="padding: 10px!important; border-radius: 0 25px 25px 0" data-testid="subauthority-container">
      <div [ngClass]="(mobile)?'container is-fluid':'container'">

        <div class="columns">
          <div class="column is-2">
            <div class="title is-4 is-darkblue " style="float: left">(2)</div>
          </div>
          <div class="column">
            <h1 class="title is-4 is-darkblue has-text-weight-bold is-uppercase is-spaceless">
              Vollmacht </h1>
            <p class="is-lightblue is-spaced mb-3 is-size-7">Vertreter an DocEstate GmbH</p>
          </div>
          <div class="column is-2">
          </div>
        </div>

        <div class="columns">
          <div class="column">

            <div>
              <app-dropzone #subauthorityDropzone [authorityType]="'subauthority'" dropzoneImage="assets/images/dropzone/upload-icon2.svg"></app-dropzone>
            </div>
            <div class="files-list" *ngIf="subAuthorityData" data-testid="subauthority-signing-container">
              <p class="is-size-6" *ngIf="subAuthorityData.signingUrl !== null" data-testid="subauthority-signing-information">Die Untervollmacht wurde unterzeichnet</p>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <button *ngIf="legitimateInterest !== 'owner'" (click)="downloadAuthorityPdfTemplate()"
                    class="is-clickable color-white has-round-border is-15 has-background-blue no-border is-bold is-pulled-right download-authority-button-padding is-flex is-align-items-center">
              <span class="is-size-7 mr-2">Vollmachtvorlage</span>
              <span class="download-icon">
                    <img alt="Download" src="assets/images/download_icon/download_icon.svg" style="height: 1rem;"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <div class="hero">
        <div style="margin-top: 5em; justify-content: inherit" class="columns">
          <div class="column is-3">
              <a routerLink="/new_order" class="button back-button is-size-6 has-round-border" style="border:none;display: block !important; color: white">
                <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                  <div class="column is-one-fifth" style="padding-right: 0px">
                    <img alt="Arrow Left" src="assets/images/button/left_btn.svg">

                  </div>
                  <div class="column">
                    <p class="is-bold" style="padding-right: 3rem; padding-bottom: 10px ;">Abbrechen</p>
                  </div>
                </div>
              </a>
          </div>
          <div class="column is-3">
          </div>
          <div class="column is-3">
            <button (click)="displayWarningMessage()" class="button buy-button is-size-6 has-round-border" [ngClass]="{'is-loading': uploadingAuthorities}" [disabled]="uploadingAuthorities" style="border:none; display: block!important; color: white" data-testid="next-page-button">
              <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
                <div class="column is-bold"><p style="padding-bottom: 10px;">Bestellzusammenfassung</p></div>

                <div class="column is-one-fifth" style="padding-left: 0px">
                  <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal id="authority-modal" [active]="showAuthorityModal" (modalClosed)="showAuthorityModal = false" #authorityModal data-testid="authority-modal">
  <app-authority-preview (authoritySigned)="setAuthorityDataFromSession()" data-testid="authority-preview"></app-authority-preview>
  <div class="columns" style="margin-top: 10px;">
    <div class="column is-one-third">
      <a (click)="authorityModal.closeModal()" class="button back-button is-size-6 has-round-border" data-testid="authority-cancel-button" style="border:none;display: block !important;">
        <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
          <div class="column is-one-fifth">
            <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
          </div>
          <div class="column">
            <p class="is-bold" style="padding-right: 2rem; padding-bottom: 10px; color: white">Abbrechen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third">
      <a (click)="downloadAuthority(authorityPreview.getAuthorityData(legitimateInterest))" class="button buy-button is-size-6 has-round-border" style="border:none;display: block !important;">
        <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
          <div class="column">
            <p class="is-bold" style="padding-bottom: 10px; color: white">PDF Herunterladen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third">
      <a (click)="authorityPreview.setAuthority(legitimateInterest)" class="button buy-button is-size-6 has-round-border" style="border:none; display: block!important;">
        <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
          <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px; color: white">Fertig</p></div>

          <div class="column is-one-fifth">
            <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
          </div>
        </div>
      </a>
    </div>
  </div>
</app-modal>

<app-modal id="subauthority-modal" [active]="showSubAuthorityModal" (modalClosed)="showSubAuthorityModal=false" #subAuthorityModal>
  <app-subauthority-preview (authoritySigned)="setSubAuthorityDataFromSession()"></app-subauthority-preview>
  <div class="columns">
    <div class="column is-one-third">
      <a (click)="subAuthorityModal.closeModal()" class="button back-button is-size-6 has-round-border" data-testid="authority-cancel-button" style="border:none;display: block !important;">
        <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
          <div class="column is-one-fifth">
            <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
          </div>
          <div class="column">
            <p class="is-bold" style="padding-right: 2rem; padding-bottom: 10px; color: white">Abbrechen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third">
      <a (click)="downloadSubAuthority(subauthorityPreview.getSubAuthorityData(legitimateInterest))" class="button buy-button is-size-6 has-round-border" style="border:none;display: block !important;">
        <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
          <div class="column">
            <p class="is-bold" style="padding-bottom: 10px; color: white">PDF Herunterladen</p>
          </div>
        </div>
      </a>
    </div>
    <div class="column is-one-third">
      <a (click)="subauthorityPreview.setAuthority(legitimateInterest)" class="button buy-button is-size-6 has-round-border" style="border:none; display: block!important;">
        <div class="columns" style="align-items: center;justify-content: center;padding-top: 5px">
          <div class="column is-bold"><p style="padding-left: 2rem; padding-bottom: 10px; color: white">Fertig</p></div>

          <div class="column is-one-fifth">
            <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
          </div>
        </div>
      </a>
    </div>
  </div>
</app-modal>

